import React from 'react';
import GetInspiredRow from './GetInspiredRow';
import { INSPIRED_BY_LOGO_BRAND_LIST, INSPIRED_BY_LOGO_STYLE_LIST, INSPIRED_BY_LOGO_TYPE_LIST } from './constants';
import './style.scss';

const GetInspired = () => (
    <div className="get-inspired-section">
        <div className="container">
            <GetInspiredRow
                className="by-logo-style"
                inspiredRowData={INSPIRED_BY_LOGO_STYLE_LIST}
                titlePrefix="by_logo_style"
            />
            <GetInspiredRow
                className="by-logo-type"
                inspiredRowData={INSPIRED_BY_LOGO_TYPE_LIST}
                titlePrefix="by_logo_type"
            />
            <GetInspiredRow
                className="by-brand-personality"
                inspiredRowData={INSPIRED_BY_LOGO_BRAND_LIST}
                titlePrefix="by_brand_personality"
            />
        </div>
    </div>
);

export default GetInspired;
